<!--POPULAR EXPERIENCE-->
<section class="popular-experiences-wrp experience-wrp christmasTheme">
    <div class="container">
        <div class="heading-text-wrp text-center mb-4">
            <h4>Most Popular Experiences</h4>
            <p>Your most favourite experiences, that became our most popular curations! Get them before someone else does!</p>
            <div class="line hidelg"></div>
        </div>

        <div class="popular-experiences-wrp-inner uk-flex uk-flex-wrap" *ngIf="responseReceived">

            <app-standard-product-card class="standardCard w-46 mlf-2" [data]="product" *ngFor="let product of products"></app-standard-product-card>

        </div>
    </div>
</section>


<!--skeleton-loader-->
<!-- <section class="popular-experiences-wrp experience-wrp">
    <div class="container">
        <div class="popular-experiences-wrp-inner uk-flex uk-flex-wrap" *ngIf="!responseReceived">
            <div class="popular-experiences-card bg-gray mb-4 w-46 uk-flex" *ngFor="let product of products">
                <ngx-skeleton-loader animation="progress" appearance="line"></ngx-skeleton-loader>
            </div>
        </div>
    </div>
</section> -->